import { Button } from "@chakra-ui/react"
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "../../ui/dialog"

const DialogBox = (props) => {
    const {
        dialog_title = null, dialog_body=null, cancelButtonName='Cancel', 
        SaveButtonName='Save', saveButtonOnclick=null, open=false, onClose,
        saveButtonVariant='solid', saveButtonColor='blue', size='md'
    } = props;
    const closeDialogBox = onClose;
    return (
        <DialogRoot motionPreset="slide-in-bottom" open={open} size={size}>
        <DialogContent>
            <DialogHeader>
                {dialog_title && <DialogTitle>{dialog_title}</DialogTitle>}
            </DialogHeader>
            <DialogBody>
            {dialog_body && <p className="text-gray-900 dark:text-white">{dialog_body}</p>}
            </DialogBody>
            <DialogFooter>
            <DialogActionTrigger asChild>
                <Button variant="outline" onClick={closeDialogBox}>{cancelButtonName}</Button>
            </DialogActionTrigger>
            <Button variant={saveButtonVariant} colorPalette={saveButtonColor} onClick={saveButtonOnclick}>{SaveButtonName}</Button>
            </DialogFooter>
            <DialogCloseTrigger onClick={closeDialogBox} />
        </DialogContent>
        </DialogRoot>
    )
}

export default DialogBox;
